import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { orderDocTypes } from '../../../../config/documents';
class DocumentField extends Component {
    constructor(props) {
        super(props);
        this.handleTypeChange = (e) => this.props.onTypeChange(e.target.value);
        this.handleCustomValueChange = (e) => this.props.onCustomValueChange(e.target.value);
        this.handleRemove = () => this.props.onRemove();
        this.state = {
            filename: '',
        };
    }
    componentDidMount() {
        try {
            const filename = this.props.doc.file.preview;
            this.setState({ filename });
        }
        catch (e) {
            console.error('DocumentField, failed to get signed URL: ', e);
        }
    }
    renderPreview() {
        const { doc } = this.props;
        if (doc.file.type.includes('image')) {
            return (React.createElement("img", { src: this.state.filename, alt: doc.file.name, className: "w-auto", style: { maxHeight: '200px' } }));
        }
        let fileIconClass;
        if (doc.file.type.endsWith('doc') || doc.file.type.endsWith('docx')) {
            fileIconClass = 'fa-file-word-o';
        }
        else if (doc.file.type.endsWith('xls') ||
            doc.file.type.endsWith('xlsx')) {
            fileIconClass = 'fa-file-excel-o';
        }
        else if (doc.file.type.endsWith('pdf')) {
            fileIconClass = 'fa-file-pdf-o';
        }
        else {
            fileIconClass = 'fa-cloud-download';
        }
        const className = classnames({
            fa: true,
            'fa-4x': true,
            [fileIconClass]: true,
        });
        return (React.createElement("a", { href: this.state.filename, target: "_blank", rel: "noreferrer" },
            React.createElement("i", { className: className })));
    }
    render() {
        const { doc, t } = this.props;
        const className = classnames({
            'form-select': true,
            'mr-2': true,
            'mb-4': doc.key === 'custom',
            error: doc.error,
        });
        return (React.createElement("div", { className: "flex flex-wrap items-center content-center shadow rounded bg-white mb-4 p-4" },
            React.createElement("div", { className: "image-wrapper w-1/2" },
                React.createElement("figure", { className: "md:mr-4 mb-2 mr-4 py-1 flex justify-center" }, this.renderPreview())),
            React.createElement("div", { className: "md:w-1/3" },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", { className: "document-field-wrapper" },
                        React.createElement("select", { className: className, value: doc.type, onChange: this.handleTypeChange },
                            React.createElement("option", { key: "empty-type", value: "" }, t('SELECT_TYPE')),
                            orderDocTypes.map((docType) => (React.createElement("option", { key: docType.value, value: docType.value }, t(docType.localizationSlug))))),
                        doc.type === 'custom' && (React.createElement("input", { type: "text", placeholder: t('ENTER_DOCUMENT_TITLE'), className: "form-field w-full", onChange: this.handleCustomValueChange }))),
                    React.createElement("button", { className: "secondary-action button", onClick: this.handleRemove },
                        React.createElement("i", { className: "fa fa-remove" }))))));
    }
}
export default withTranslation()(DocumentField);
DocumentField.propTypes = {
    doc: PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
        id: PropTypes.string.isRequired,
    }),
    onCustomValueChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};
